const csvHeaderMapping = [
  { id: "legacyID", name: "Alert Number" },
  { id: "sportName", name: "Sport" },
  { id: "eventDateTime", name: "Event Date" },
  { id: "locationName", name: "Location" },
  { id: "continent", name: "Continent" }, 
  { id: "tournamentName", name: "Competition" },
  { id: "tournamentLevelName", name: "Tour" },
  { id: "gender", name: "Gender" },
  { id: "eventName", name: "Event" },
  { id: "customerLocationsCountry", name: "Suspicious Customer Country" },
  { id: "customerLocationsState", name: "Suspicious Customer State" },
  { id: "valueITF", name: "Value (ITF)" }, 
  { id: "timeOfBet", name: "Prematch/Live" },
  { id: "createdByGroupName", name: "Raiser" },
  { id: "assignee", name: "Reporter/Evaluater" }, 
  { id: "suspiciousCount", name: "No of O/S Replies" }, 
  { id: "reportedTo", name: "Reported to" }, 
  { id: "createdAt", name: "Date Reported" },
  { id: "regInformed", name: "Reg Informed by IBIA" }, 
  { id: "opposedPlayer", name: "Opposed Player" },
  { id: "marketTags", name: "Market Tags" },
];
export const continentMap = {
  Africa: new Set([
    "Algeria","Angola","Benin","Botswana","Burkina Faso","Burundi","Cameroon",
    "Chad","Comoros","Congo","Congo (the Democratic Republic of the)",
    "Djibouti","Egypt","Equatorial Guinea","Eritrea","Eswatini","Ethiopia",
    "Gabon","Gambia","Ghana","Guinea","Guinea-Bissau","Ivory Coast","Kenya",
    "Lesotho","Liberia","Libya","Madagascar","Malawi","Mali","Mauritania",
    "Mauritius","Mayotte","Morocco","Mozambique","Namibia","Niger","Nigeria",
    "Reunion","Rwanda","Sao Tome and Principe","Senegal","Seychelles",
    "Sierra Leone","Somalia","South Africa","South Sudan","Sudan","Tanzania, United Republic of",
    "Togo","Tunisia","Uganda","Western Sahara","Zambia","Zimbabwe", "British Indian Ocean Territory", "Central African Republic","Côte d'Ivoire"
  ]),

  Asia: new Set([
    "Afghanistan","Armenia","Azerbaijan","Bahrain","Bangladesh","Bhutan",
    "Brunei Darussalam","Cambodia","China","Georgia","Hong Kong","India",
    "Indonesia","Iran (Islamic Republic of)","Iraq","Israel","Japan","Jordan",
    "Kazakhstan","Korea (the Democratic People's Republic of)",
    "Korea (the Republic of)","Kuwait","Lao People's Democratic Republic",
    "Lebanon","Macao","Malaysia","Maldives","Mongolia","Myanmar","Nepal",
    "Oman","Pakistan","Philippines","Qatar","Saudi Arabia","Singapore",
    "Sri Lanka","Syrian Arab Republic","Taiwan (Province of China)",
    "Thailand","Timor-Leste","Turkey","Turkmenistan","United Arab Emirates",
    "Uzbekistan","Viet Nam","Yemen","Palestine, State of", "Kyrgyzstan"
  ]),

  Europe: new Set([
    "Albania","Andorra","Austria","Belarus","Belgium","Bosnia and Herzegovina",
    "Bulgaria","Croatia","Cyprus","Czechia","Denmark","Estonia","Finland",
    "France","Germany","Gibraltar","Greece","Guernsey","Holy See","Hungary",
    "Iceland","Ireland","Isle of Man","Italy","Jersey","Kosovo","Latvia",
    "Liechtenstein","Lithuania","Luxembourg","Malta","Moldova (the Republic of)",
    "Monaco","Montenegro","Netherlands","North Macedonia","Norway","Poland",
    "Portugal","Romania","Russian Federation","San Marino","Serbia","Slovakia",
    "Slovenia","Spain","Sweden","Switzerland","Ukraine",
    "United Kingdom of Great Britain and Northern Ireland","Aland Islands"
  ]),

  NorthAmerica: new Set([
    "Canada","United States of America","Mexico","Greenland","Bermuda",
    "Bahamas","Barbados","Belize","Costa Rica","Cuba","Dominica",
    "Dominican Republic","El Salvador","Grenada","Guadeloupe","Guatemala",
    "Haiti","Honduras","Jamaica","Martinique","Montserrat","Nicaragua",
    "Panama","Puerto Rico","Saint Barthelemy","Saint Kitts and Nevis",
    "Saint Lucia","Saint Martin (French part)",
    "Saint Vincent and the Grenadines",
    "Trinidad and Tobago","Turks and Caicos Islands",
    "Virgin Islands (British)","Virgin Islands (U.S.)","Cayman Islands",
    "Sint Maarten (Dutch part)","Aruba"
  ]),

  SouthAmerica: new Set([
    "Argentina","Bolivia (Plurinational State of)","Brazil","Chile","Colombia",
    "Ecuador","French Guiana","Guyana","Paraguay","Peru","Suriname","Uruguay",
    "Venezuela (Bolivarian Republic of)","Falkland Islands [Malvinas]"
  ]),

  Oceania: new Set([
    "Australia","Cook Islands","Fiji","French Polynesia","Guam","Kiribati",
    "Marshall Islands","Micronesia (Federated States of)","Nauru",
    "New Caledonia","New Zealand","Niue","Norfolk Island",
    "Northern Mariana Islands","Palau","Papua New Guinea","Samoa",
    "Solomon Islands","Tokelau","Tonga","Tuvalu","Vanuatu",
    "Wallis and Futuna","American Samoa"
  ]),

  Antarctica: new Set([
    "Antarctica","Bouvet Island","Heard Island and McDonald Islands",
    "South Georgia and the South Sandwich Islands",
    "French Southern Territories"
  ])
};


export const escapeCSVValue = (value) => {
    if (typeof value === 'string') {
        value = value.replace(/"/g, '""');
        if (value.includes(',') || value.includes('\n') || value.includes('"')) {
            return `"${value}"`;
        }
    }
    return value;
};

const convertToCSV = (data, headers) => {
const headerRow = headers.map(header => header.name).join(',') + '\n';
const csvRows = data.map(row => {
    return headers
    .map(header => {
        const value = row[header.id] ?? '';
        return escapeCSVValue(value);
    })
    .join(',');
});
return headerRow + csvRows.join('\n');
};
export const handleExportCSV = (alertData) => {
    const csvData = convertToCSV(alertData, csvHeaderMapping);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'Alerts.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
